import { FormatDateWTime } from "../../../../utils/FormatData";

export const getCampaignDetailReportData = ({ data = {}, type = "sms" }) => {
  const {
    i_sent = 0,
    i_total = 0,
    i_sms = 0,
    i_waiting = 0,
    i_programmed = 0,
    i_invalid = 0,
    i_deliver = 0,
    i_readed = 0,
    i_actions = 0,
    tst_first = "",
    tst_last = "",
    i_replies = 0,
  } = data || {};

  const total = Number(i_total) || 0;
  const sent = Number(i_sent) || 0;
  const percentage = total > 0 ? ((sent / total) * 100).toFixed(2) : "0.00";

  const cards = [
    {
      icon: "sms",
      color: "text-gray-700",
      value: total,
      title: "Total",
      type: ["sms", "rcs"],
    },
    {
      icon: "send",
      color: "text-zinc-500",
      value: i_sent ?? 0,
      title: "Enviados",
      type: ["sms", "rcs"],
    },
    {
      icon: "check",
      color: "text-blue-500",
      value: i_deliver ?? 0,
      title: "Entregados",
      type: ["rcs"],
    },
    {
      icon: "alt_route",
      color: "text-blue-500",
      value: i_sms ?? 0,
      title: "Fallback (SMS)",
      type: ["rcs"],
    },
    {
      icon: "done_all",
      color: "text-blue-500",
      value: i_readed ?? 0,
      title: "Leídos",
      type: ["rcs"],
    },
    {
      icon: "ads_click",
      color: "text-blue-500",
      value: i_actions ?? 0,
      title: "Acciones",
      type: ["rcs"],
    },
    {
      icon: "quickreply",
      color: "text-green-700",
      value: i_replies ?? 0,
      title: "Respuestas",
      type: ["rcs"],
    },
    {
      icon: "thumb_down",
      color: "text-red-500",
      value: i_invalid ?? 0,
      title: "Rechazados",
      type: ["rcs"],
    },
  ].filter((item) => item.type.includes(type));

  const details = [
    {
      label: "Entregados",
      value: type === "sms" ? i_sent : i_deliver,
      show: true,
    },
    {
      label: "Fallbacks (sms)",
      value: i_sms,
      show: type === "rcs",
    },
    {
      label: "Leídos",
      value: i_readed,
      show: true,
    },
    {
      label: "En proceso",
      value: type === "sms" ? i_programmed : i_waiting,
      show: true,
    },
    {
      label: "Total",
      value: i_total,
      show: true,
    },
    {
      label: "Enviados",
      value: i_sent,
      show: true,
    },
    {
      label: "Confirmados",
      value: i_deliver,
      show: true,
    },
    {
      label: "Inválidos",
      value: i_invalid,
      show: true,
    },
    {
      label: "Acciones",
      value: i_actions,
      show: type === "rcs",
    },
    {
      label: "Respuestas",
      value: i_replies,
      show: type === "rcs",
    },
    {
      label: "Inicio de Envío",
      value: tst_first ? FormatDateWTime(tst_first) : " - ",
      show: true,
    },
    {
      label: "Última Entrega",
      value: tst_last ? FormatDateWTime(tst_last) : " - ",
      show: true,
    },
  ].filter((item) => item.show);

  return {
    cards,
    details,
    percentage,
    sent,
    total,
  };
};
